import UserIcon from "../../assets/img/user-icon.svg";

const UserPreviewCard = ({ data }) => {
  return (
    <div className="earner-card mb-3">
      <div className="earner-info align-items-center justify-content-between gap-2 d-flex mb-0">
        <div className="align-items-center gap-2 d-flex">
          <div className="earner-thumbnail-wrapper">
            <img src={UserIcon} alt="User Icon" />
          </div>
          <h4 className="earner-name">
            {`${data?.fname ?? ""} ${data?.lname ?? ""}`}
          </h4>
        </div>
      </div>
    </div>
  );
};

export default UserPreviewCard;
